import { CountryCode } from '@carsys/enums/country-code'
import { IWholesalerOrderSystem, OrderSystem } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { loadWholesalerOrdersystems } from '../state/actions'
import { wholesalerOrderSystemKey } from './cache-keys'
import { orderSystemFieldMapper, orderSystemsToDropdownOptions, wholesalerFieldsToFieldValues } from './fieldMapper'

export const useGetWholesalerOrderSystem = (
  country: CountryCode,
  selectedOrderSystem: OrderSystem,
  wholesalerOrderSystemSettings: { [k: string]: string },
  onSuccess?: (data: {
    WholesalerOrderSystem: IWholesalerOrderSystem | undefined
    WholesalerOrderSytemDropdownOptions: ReturnType<typeof orderSystemsToDropdownOptions>
    WholesalerOrderSystemFields: ReturnType<typeof orderSystemFieldMapper>
    OrderSystemSettings: ReturnType<typeof wholesalerFieldsToFieldValues>
  }) => void
) => {
  const dispatch = useDispatch()

  return useQuery(
    wholesalerOrderSystemKey(country, selectedOrderSystem),
    async () => {
      const { Data: orderSystemData } = await dispatch(loadWholesalerOrdersystems(country))

      const currentWholeslalerSystem = orderSystemData.find(o => o.Name === selectedOrderSystem)

      return {
        WholesalerOrderSystem: currentWholeslalerSystem,
        WholesalerOrderSystemFields: orderSystemFieldMapper(currentWholeslalerSystem),
        WholesalerOrderSytemDropdownOptions: orderSystemsToDropdownOptions(orderSystemData),
        OrderSystemSettings: wholesalerFieldsToFieldValues(wholesalerOrderSystemSettings, currentWholeslalerSystem?.WholesalerFields || [])
      }
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
